module.exports = __webpack_public_path__ + "static/media/presupuesto_det.491a5bf9.png";